import React, { Component } from 'react';

import {numberWithCommas} from './../../../utils/utils';

import {isIframed} from './../../../utils/gsntv';

import './../../../../scss/App.scss';

class Leaderboard extends Component {

	constructor(props){
		super(props);

		this.transitionIn = new window.TimelineMax();

		this.state = {

		}
	}

	componentDidMount(){

		// twweens

		window.TweenMax.set(this.refs.wipe, {"width":"100%"});
		window.TweenMax.set(this.refs.header, {"alpha":"0", "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.content, {"alpha":"0", "transform":"translateY(1vw)"});

		this.transitionIn.to(this.refs.wipe, .4, {"width": "0%", delay:.2})
			.to(this.refs.header, .5, {"alpha":"1", "transform":"translateY(0vw)"}, "-=.2")
			.to(this.refs.content, .5, {"alpha":"1", "transform":"translateY(0vw)"}, "-=.2");


	}

	componentDidUpdate(prevProps, prevState){
		if(this.props.landingTransitionOut === true && prevProps.landingTransitionOut === false){
			this.transitionIn.reverse();
		}
	}

	render() {
		console.log("Leaderboard :: render redux props", this.props.user);

		const highScoreData = (isIframed())? window.highScores.scores : window.leaderboard.leaderboard;
		const month = (isIframed())? window.highScores.month : '';
	
		return (
			 <div id="leaderboard" ref="leaderboard">
				 <div className="content">
				 	<div className="month-header">{month}</div>
					<div className="header" ref="header"></div>
				 	<table ref="content">
				 		<tbody>
					 		{
					 			highScoreData.map((item, index) => (
					 				<tr key={index}>
							 			<td>{index + 1}. {item.name}</td>
							 			<td>{numberWithCommas(item.score)}</td>
					 				</tr>
					 			))
					 		}
				 		</tbody>
				 	</table>
				 </div>
		 		<div className="wipe" ref="wipe"></div>
			</div>
		);
	}
}

export default Leaderboard;



// WEBPACK FOOTER //
// ./src/js/components/landingpage/leaderboard/Leaderboard.js